import { ResidentSearchModel } from './resident-search-model';

export class ResidentSearchModelResponse {
    errors: string[];
    residentList: ResidentSearchModel[];
}
